import type { CSSProperties, ReactNode } from "react";

const cardStyles = {
  color: "#465357",
  paddingBottom: "20px",
  overflow: "hidden",
  borderRadius: "4px",
  marginBottom: "20px",
  border: "1px solid #F5F5F5",
  backgroundColor: "#FFFFFF",
} as CSSProperties;

export function Card({ children, style }: { children: ReactNode; style?: CSSProperties }) {
  return <div style={{ ...cardStyles, ...style }}>{children}</div>;
}
